import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import './style.css';
import { StateProvider } from './Store'

ReactDOM.render(<StateProvider><App /></StateProvider>, document.getElementById('root'))
